module.exports = __webpack_public_path__ + "assets/img/banner.58e3cf98.png";